<template>
    <div class="ht-tab-wrap">
      <div class="section-title-wrapper text-center section-space--mb_30">
        <h5 class="section-title font-width-light wow move-up">Pieds diabétiques</h5>
      </div>
      <div class="row">
<!--        <div class="col-md-4">-->
<!--          <img class="img-fluid" src="@/assets/img/pied-pro/services/ongle-incarne1.jpg" alt="product-details" />-->
<!--        </div>-->
        <div class="col-md-12" style="color: #05052d">
          <div class="float-left picture-mobile-tab" style="margin-right: 20px;">
            <img class="img-fluid" src="@/assets/img/pied-pro/services/pied-diabetique.jpg" alt="Pieds diabétiques" />
          </div>
          On observe très souvent des problèmes des pieds qui peuvent entraîner de graves complications chez les
          personnes atteintes du diabète.
          <br><br>
          Cette maladie chronique peut causer des lésions nerveuses et une mauvaise circulation du sang dans les jambes
          et les pieds. C’est pourquoi les personnes atteintes du diabète ont moins tendance à ressentir certaines
          blessures aux pieds, comme les ampoules ou les coupures qui peuvent s’infecter rapidement et entraîner de
          sérieuses complications telles que les ulcères (plaies).
          <br><br>
          La prévention est donc le meilleur remède. N’attendez pas pour prendre rendez-vous avec votre podiatre.
          Il sera en mesure d’évaluer l’état de santé général de vos pieds en effectuant des tests vasculaires et
          neurologiques et pourra détecter les zones de pressions anormales de vos pieds.
          Il pourra vous donner les soins et conseils spécifiques à votre condition.
        </div>
      </div>
    </div>
</template>

<script>
    export default {
        name: 'OnglesIncarnes',
    };
</script>